export default __webpack_public_path__ + "static/media/Snd_MagicC.23a72d75.mp3";